import { GlossaryTerm } from '~/types';
import findMatch from '~/ui/components/TextWithTerms/utils/findMatch';

const createTextChunk = (content: string) => ({
  type: 'text' as const,
  content,
});

const createTermChunk = (content: string, term: GlossaryTerm) => ({
  type: 'term' as const,
  content,
  term,
});

type TermChunk = ReturnType<typeof createTermChunk>;
type TextChunk = ReturnType<typeof createTextChunk>;

const toChunksByTerms = ({ terms, fullString }: { terms: GlossaryTerm[]; fullString: string }) => {
  let lastEndPos = 0;
  let chunks: (TermChunk | TextChunk)[] = [];
  let termIndex = 0;

  while (true) {
    const term = terms[termIndex];

    if (!term) {
      const textPart = fullString.substring(lastEndPos, fullString.length);

      if (textPart) {
        chunks.push(createTextChunk(textPart));
      }

      break;
    }

    const textPart = fullString.substring(lastEndPos, term.position || lastEndPos);

    if (textPart) {
      chunks.push(createTextChunk(textPart));
    }

    const { endPos, textMatch } = findMatch(term, fullString);
    chunks.push(createTermChunk(textMatch, term));

    lastEndPos = endPos;
    termIndex++;
  }

  return chunks;
};

export default toChunksByTerms;
